import { Box } from "@govlaunch/web";
import React from "react";

export default function CollectionCardBottomCorner() {
  return (
    <Box
      position="absolute"
      width="245px"
      height="1px"
      transform="translateY(15px) translateX(32px) rotate(-30deg)"
      borderBottom="1px"
      borderColor="currentColor"
      bottom={45}
      right={-9}
      opacity={0.25}
    />
  );
}
